import './ButtonWithBotErrors.styles.css';

import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import React, { FC, useCallback, useEffect, useMemo } from 'react';

import botErrorStore from '../../../../store/BotErrorStore';
import gameStore from '../../../../store/GameStore';
import tableStore from '../../../../store/TableStore';
import BotErrorWindow from '../../../BotErrorWindow/BotErrorWindow';
import { ButtonWithBotErrorsProps } from './ButtonWithBotErrors.types';

const ButtonWithBotErrors: FC<ButtonWithBotErrorsProps> = ({ tableId }) => {
  useEffect(() => {
    Array.from(botErrorStore.toggleBotErrorEventMap.keys()).forEach(tableId => {
      if (!tableStore.isTableViewing(tableId)) {
        botErrorStore.removeToggleEvent(tableId);
      }
    });
  }, [tableId, gameStore.activeGames.size, tableStore.viewingTableIds.length]);

  const getToggleBotErrorEvent = useCallback(
    () => botErrorStore.toggleBotErrorEventMap.get(tableId),
    [botErrorStore.toggleBotErrorEventMap.size, tableId],
  );

  const unreadBotErrorsCount = useMemo(
    () => botErrorStore.getUnreadBotErrorsCount(tableId),
    [tableId, botErrorStore.botErrorsStateChanged],
  );

  const getUnreadBotErrorsBadge = useMemo(() => {
    const unreadBotErrorsNumber = unreadBotErrorsCount;
    return unreadBotErrorsNumber > 0
      ? unreadBotErrorsNumber.toString()
      : undefined;
  }, [unreadBotErrorsCount]);

  const table = useMemo(
    () => tableStore.getActiveTableById(tableId),
    [tableId, tableStore.activeTables.size],
  );

  return (
    table && (
      <>
        <Button
          className={unreadBotErrorsCount > 9 ? 'expandable-button' : ''}
          icon="pi pi-microchip-ai bot-error-button-icon"
          badge={getUnreadBotErrorsBadge}
          badgeClassName="p-badge-danger m-0"
          rounded
          text
          aria-label="errors"
          tooltip="AI errors"
          onClick={event =>
            botErrorStore.addToggleBotErrorEventMap(tableId, event)
          }
        />
        <BotErrorWindow table={table} toggleEvent={getToggleBotErrorEvent()} />
      </>
    )
  );
};

export default observer(ButtonWithBotErrors);
